require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-fourdrinier-house-the-warehouse-style-apartments-coming-soon.json") })
        }
      }, "path---news-fourdrinier-house-the-warehouse-style-apartments-coming-soon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-fourdrinier-house-the-warehouse-style-apartments-coming-soon!./.cache/json/news-fourdrinier-house-the-warehouse-style-apartments-coming-soon.json
// module id = 811
// module chunks = 231608221292675